module.exports = __webpack_public_path__ + "img/VL_06_02.5358104f.png";